import Big from 'big.js';
import { produce } from 'immer';

export function formatAmount(value) {
  try {
    return new Big(value).div(100).toNumber();
  } catch (error) {
    return 0;
  }
}

export function formatCount(value) {
  try {
    return new Big(value).toNumber();
  } catch (error) {
    return 0;
  }
}

export function shapeSurveyFormDataForAPI(formData) {
  function callback(draft) {
    if (draft.sales_channels.other_enabled === false && draft.sales_channels.other !== '') {
      draft.sales_channels.other = '';
    }

    if (draft.seller_categories.other_enabled === false && draft.seller_categories.other !== '') {
      draft.seller_categories.other = '';
    }

    delete draft.sales_channels.other_enabled;
    delete draft.seller_categories.other_enabled;
  }

  return produce(callback)(formData);
}

